import {useEffect, useRef, useState} from "react";
import './groupCard.css'
import {FormattedMessage, useIntl} from "react-intl";
import {GROUP_HIDDEN, GROUP_PRIVATE, GROUP_PUBLIC} from "../../../utils/consts";
import auth from "../../../utils/authentication";
import {getGroupPhotoUrl, isMediumScreen, isMobileDevice, isSmallScreen} from "../../../utils/utils";
import functions from "../../../utils/functionsFirebase";
import {useDispatch} from "react-redux";
import groups from "../index"
import {toast} from "react-toastify";
import ItemBackdropDetails from "../../cap17drive/shared/item-backdrop-details/item-backdrop-details";
import {useNavigate} from "react-router-dom";

function GroupCard({group, joined, asked, invited, onClick}) {

    const dispatch = useDispatch();
    const intl = useIntl();

    const categoriesDiv = useRef(null);
    const containerDiv = useRef(null);
    const [overflow, setOverflow] = useState(false);
    const [loadingJoin, setLoadingJoin] = useState(false);
    const navigate = useNavigate();

    const creator = group.uidCreator === auth.currentUser.uid;

    const colSize = isSmallScreen() ? 3 : (isMediumScreen() ? 2 : (isMobileDevice() ? 1 : 2))


    useEffect(() => {
        if (categoriesDiv?.current && containerDiv?.current) {
            const contentHeight = categoriesDiv.current?.scrollWidth;
            const divHeight = containerDiv.current?.scrollWidth;
            if (contentHeight > divHeight) {
                setOverflow(true);
            } else {
                setOverflow(false);
            }
        }
    }, [window.outerWidth])

    async function joinGroup(group, e, invited) {
        if (e) {
            e.preventDefault();
        }
        setLoadingJoin(true);

        try {
            const joinGroupFunction = functions.httpsCallable("joinGroup");
            const res = await joinGroupFunction({groupId: group.id});
            if (res.data.error) {
                toast.error(intl.formatMessage({id: "groups.group-limit-reached"}));
                setLoadingJoin(false);
                return false;
            }
            if (group.privacy === GROUP_PUBLIC || invited) {
                group = res.data;
                dispatch(groups.actions.addNewGroup(group));
                dispatch(groups.actions.updateSearchedGroup(group))
            } else {
                dispatch(groups.actions.askedNewGroup(group));
            }
            setLoadingJoin(false);
        } catch (e) {
            // Error joining the group because the group has been deleted
            toast.error(intl.formatMessage({id: "groups.join-group.error"}));
            setLoadingJoin(false);
            return false;
        }
        return true;
    }

    function getGroupUrl() {
        if ((group.privacy === GROUP_PUBLIC || joined) && !invited && !loadingJoin) {
            return "/groups/group-details/" + group.id;
        } else {
            return ""
        }
    }

    async function acceptJoinGroup(group, uid, accept) {
        if (accept) {
            if (await joinGroup(group, null, true)) {
                dispatch(groups.actions.deleteInvite(group));
            }
        } else {
            setLoadingJoin(true);
            const deleteInvitation = functions.httpsCallable('deleteGroupInvitation');
            const res = await deleteInvitation({groupId: group.id});
            dispatch(groups.actions.deleteInvite(group));
            setLoadingJoin(false);
        }
    }


    return <ItemBackdropDetails
        cachedSrc={getGroupPhotoUrl(group)}
        onClickPoster={() => {
            if (onClick) {
                onClick();
            }
            navigate(getGroupUrl());
        }}
        aspectRatio={"1 / 1"}
        overlay={{
            topLeft: creator && <span style={{color: "gold", fontSize: "small"}}>
                                    <i className="fa-solid fa-crown"></i>&nbsp;
                <FormattedMessage id="groups.group-leader"/>
                                </span>,
            bottomRight: <>{group.joinedUsers}<i className="fa-solid fa-user ps-1"></i></>,
        }}
        detailsTitle={<>
            {group.privacy === GROUP_HIDDEN && <i className="fa-solid fa-eye-slash pe-2"></i>}
            {group.privacy === GROUP_PUBLIC && <i className="fa-solid fa-lock-open pe-2"></i>}
            {group.privacy === GROUP_PRIVATE && <i className="fa-solid fa-lock pe-2"></i>}
            {group.groupName}
        </>}
        detailsSubtitle={group.categories?.join(', ')}
        hideOptionsIcon={true}
    />;
    /*return (
        <Link className="card mb-3 button-group" to={getGroupUrl()} ref={containerDiv} onClick={() => {
            if (onClick) {
                onClick();
            }
        }}>
            <div
                className={"d-flex flex-row align-items-center pt-1 pe-2 ps-1 " + (!group?.categories?.length && "pb-1")}>

                <div className={"col-" + (12 - colSize) + " p-2 ps-2"}>

                    <hr className="mb-1 mt-1"/>
                    <div className="d-flex flex-row justify-content-between align-items-center">
                        {(joined || invited) && <div className="d-flex flex-row align-items-center">
                            {invited &&
                                <Fragment>
                                    <span className="ms-2">
                                        <FormattedMessage id="groups.invitation"/>:
                                    </span>
                                    <IconButton disabled={loadingJoin}
                                                onClick={(e) => acceptJoinGroup(group, auth.currentUser.uid, true)}
                                                icon="fa-solid fa-check fa-lg text-success"
                                                className="ms-2 me-1"/>
                                    <IconButton disabled={loadingJoin}
                                                onClick={(e) => acceptJoinGroup(group, auth.currentUser.uid, false)}
                                                icon="fa-solid fa-xmark fa-lg text-danger"
                                                className="ms-1"/>
                                    {loadingJoin && <i className="fa-solid fa-spinner fa-spin ms-2 fa-lg"></i>}
                                </Fragment>}
                        </div>}
                        {!joined && !invited && !asked &&
                            <div>
                                <button className="btn btn-sm btn-outline-secondary" disabled={loadingJoin}
                                        onClick={(e) => {
                                            joinGroup(group, e);
                                        }}>
                                    <Fragment>
                                        {group.privacy === GROUP_PUBLIC && <Fragment>
                                            <i className="fa-solid fa-lock-open"></i> <FormattedMessage
                                            id="groups.join-group"/>
                                        </Fragment>}
                                        {group.privacy === GROUP_PRIVATE && !asked && <Fragment>
                                            <i className="fa-solid fa-lock"></i> <FormattedMessage
                                            id="groups.ask-to-join"/>
                                        </Fragment>}
                                        {loadingJoin && <i className="fa-solid fa-spinner fa-spin ms-2 fa-lg"></i>}
                                    </Fragment>
                                </button>
                            </div>}
                        {!joined && asked &&
                            <div>
                                <i className="fa-solid fa-lock"></i> <FormattedMessage id="groups.already-asked"/>
                            </div>}
                        <div>
                        </div>
                        <div>
                            {group.joinedUsers}&nbsp;<i className="fa-solid fa-users"></i>
                        </div>
                    </div>
                </div>
            </div>
            {group?.categories?.length > 0 &&
                <div className="d-flex flex-row">
                    {overflow && <div className="col-1 d-grid ps-1 pt-1 pb-1">
                        <button type="button" className="btn btn-outline-secondary button-scroll-categories"
                                onClick={(e) => {
                                    e.preventDefault();
                                    categoriesDiv.current.scrollLeft -= containerDiv.current?.scrollWidth * 0.7;
                                }}>
                            <i className="fa-solid fa-angle-left"></i>
                        </button>
                    </div>}
                    <div ref={categoriesDiv}
                         className={"d-flex flex-row mt-1 pb-1 ps-1 pe-1 categories-badges " + (overflow && "col-10")}>
                        {group.categories.map((x, i) => {
                            const last = i === group.categories.length - 1;
                            return <span key={x}
                                         className={"badge rounded-pill text-bg-secondary " + (!last && "me-1")}>{x}</span>
                        })}
                    </div>
                    {overflow && <div className="col-1 d-grid pe-1 pt-1 pb-1">
                        <button type="button" className="btn btn-outline-secondary button-scroll-categories"
                                onClick={(e) => {
                                    e.preventDefault();
                                    categoriesDiv.current.scrollLeft += containerDiv.current?.scrollWidth * 0.7;
                                }}>
                            <i className="fa-solid fa-angle-right"></i>
                        </button>
                    </div>}
                </div>}
        </Link>
    );*/
}

export default GroupCard;
